import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    startDate: "",
    endDate: "",
    serviceType: "",
    paymentType: "",
    paymentStatus: "",
    orderStatus: "",
};

const viewOrderFilterSlice = createSlice({
    name: "viewOrderFilter",
    initialState: initialState,
    reducers: {
        onClearFilter(state) {
            state.startDate = '';
            state.endDate = '';
            state.serviceType = '';
            state.paymentType = '';
            state.paymentStatus = '';
            state.orderStatus = '';
        },
        onChangeFilter(state, action) {
            const { key, value } = action.payload;
            state[key] = value
        }
    },
})

export const {onClearFilter,onChangeFilter} = viewOrderFilterSlice.actions;
export default viewOrderFilterSlice.reducer;